function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M474.751 36.1092V674.009C474.751 689.736 462.005 702.477 446.279 702.477H89.1719C73.4451 702.477 60.6992 689.736 60.6992 674.009V36.1092C60.6992 20.3824 73.4451 7.63647 89.1719 7.63647H446.279C462.005 7.63647 474.751 20.3824 474.751 36.1092Z",
  fill: "#EBE3FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M198.853 622.173H371.939C377.366 622.173 381.764 617.775 381.764 612.347V559.109C381.764 553.682 377.366 549.284 371.939 549.284H198.853C193.426 549.284 189.027 553.682 189.027 559.109V612.347C189.027 617.775 193.431 622.173 198.853 622.173Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M154.114 517.189H328.345C333.454 517.189 337.595 513.048 337.595 507.939V461.812C337.595 456.703 333.454 452.562 328.345 452.562H154.114C149.004 452.562 144.863 456.703 144.863 461.812V507.939C144.863 513.048 149.004 517.189 154.114 517.189Z",
  fill: "#0056D2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M467.499 7.63647H66.7578V274.771H467.499V7.63647Z",
  fill: "#F0F6FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M447.013 710.118H88.4386C69.1458 710.118 53.4492 693.584 53.4492 673.262V36.8556C53.4492 16.5338 69.1458 0 88.4386 0H447.013C466.306 0 482.003 16.5338 482.003 36.8556V673.262C482.003 693.584 466.306 710.118 447.013 710.118ZM88.4437 15.2729C77.1454 15.2729 67.9554 24.9571 67.9554 36.8556V673.262C67.9554 685.161 77.1454 694.845 88.4437 694.845H447.018C458.316 694.845 467.511 685.161 467.511 673.262V36.8556C467.511 24.9571 458.322 15.2729 447.018 15.2729H88.4437Z",
  fill: "#0056D2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M445.119 702.244H79.1858C68.7248 702.244 60.2461 693.766 60.2461 683.305V657.651H475.201V672.163C475.201 688.772 461.734 702.244 445.119 702.244Z",
  fill: "#0056D2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M168.384 581.317C168.384 589.297 166.155 596.741 162.296 603.097C162.296 603.107 162.286 603.107 162.286 603.117C161.222 604.862 160.032 606.537 158.725 608.1C157.888 609.099 157.015 610.067 156.097 610.99C153.868 613.22 151.402 615.197 148.713 616.877C142.973 620.488 136.29 622.733 129.123 623.192C128.24 623.247 127.337 623.277 126.434 623.277C117.88 623.277 109.931 620.715 103.298 616.317C101.301 615 99.4294 613.512 97.6943 611.883C94.5369 608.907 91.8384 605.462 89.725 601.639C86.3859 595.622 84.4844 588.691 84.4844 581.317C84.4844 569.742 89.1803 559.25 96.7713 551.654C104.362 544.068 114.849 539.377 126.434 539.377C138.02 539.377 148.501 544.073 156.097 551.654C163.688 559.25 168.384 569.742 168.384 581.317Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M357.379 486.427C357.379 498.472 362.458 509.336 370.589 516.988C378.094 524.054 388.207 528.382 399.329 528.382C400.232 528.382 401.13 528.352 402.022 528.296C412.534 527.63 421.991 523.096 428.992 516.095C429.91 515.177 430.788 514.209 431.625 513.21C432.931 511.631 434.127 509.962 435.191 508.206C439.054 501.861 441.279 494.406 441.279 486.432C441.279 474.851 436.583 464.36 428.992 456.769C421.401 449.178 410.915 444.482 399.329 444.482C387.743 444.482 377.257 449.178 369.666 456.769C362.075 464.36 357.379 474.846 357.379 486.427Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M374.971 505.427C375.712 505.942 376.539 506.37 377.452 506.708C383.989 512.398 394.385 521.578 402.031 528.296C412.542 527.63 422 523.096 429.001 516.095C429.919 515.177 430.796 514.209 431.634 513.21C432.94 511.631 434.135 509.962 435.2 508.206C434.297 506.607 433.217 504.988 431.946 503.344C425.198 494.613 419.695 491.652 421.203 480.379C422.02 474.261 418.091 452.628 404.033 451.513C402.858 451.417 395.762 450.227 390.617 451.654C378.153 455.104 360.626 495.536 374.971 505.427Z",
  fill: "#233862"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M389.504 503.016C389.439 503.041 395.34 506.592 400.011 505.629C404.404 504.726 408.868 498.789 408.807 498.769C407.002 498.29 405.347 496.262 406.063 485.469L405.226 485.579L391.154 487.451C391.154 487.451 391.194 491.844 390.942 495.965C390.74 499.43 390.322 502.698 389.504 503.016Z",
  fill: "#FFB27D"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M391.161 487.456C391.161 487.456 391.201 491.849 390.949 495.97C398.742 496.242 403.297 489.408 405.233 485.58L391.161 487.456Z",
  fill: "#ED975D"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M388.313 491.193C388.313 491.193 406.693 492.661 407.429 481.201C408.165 469.742 411.035 462.211 399.329 460.794C387.627 459.372 385.059 463.598 383.884 467.366C382.709 471.124 383.551 490.518 388.313 491.193Z",
  fill: "#FFB27D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M385.859 461.419C385.859 461.419 395.16 473.747 402.766 476.223C410.373 478.7 413.858 476.838 413.858 476.838C413.858 476.838 410.095 472.042 408.668 465.303C408.244 463.316 406.797 461.702 404.855 461.107C399.402 459.422 388.926 456.925 385.859 461.419Z",
  fill: "#233862"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M393.196 462.08C393.196 462.08 388.571 464.95 386.775 467.437C385.04 469.832 383.32 476.087 383.703 478.806C383.703 478.806 380.248 465.928 384.843 461.026C389.706 455.826 393.196 462.08 393.196 462.08Z",
  fill: "#233862"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M370.594 516.988C378.099 524.054 388.212 528.382 399.334 528.382H402.118C402.088 528.357 402.058 528.326 402.022 528.296C412.534 527.63 421.991 523.096 428.992 516.095C429.91 515.177 430.787 514.209 431.625 513.21C430.167 510.047 428.775 507.475 427.569 505.8C422.369 498.547 407.344 497.624 407.344 497.624V497.629C407.344 497.634 407.338 497.629 407.333 497.634C407.303 497.655 407.273 497.665 407.248 497.685C401.528 501.059 397.765 502.128 395.299 502.128C391.652 502.128 390.82 499.818 390.663 499.233C390.663 499.228 390.663 499.228 390.663 499.228L390.658 499.223V499.213C390.638 499.137 390.638 499.092 390.638 499.092V499.087C390.638 499.087 379.794 500.923 374.962 505.427C373.943 506.37 373.196 507.435 372.874 508.625C372.47 510.103 371.643 513.139 370.594 516.988Z",
  fill: "#00E7C5"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5816 430.435H362.731C372.995 430.435 381.312 422.112 381.312 411.853V317.22C381.312 306.956 372.99 298.638 362.731 298.638H18.5816C8.31734 298.638 0 306.961 0 317.22V411.848C0 422.112 8.31734 430.435 18.5816 430.435Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M123.538 364.526C123.538 373.908 120.921 382.669 116.381 390.144C116.381 390.154 116.371 390.154 116.371 390.164C115.12 392.217 113.718 394.184 112.185 396.025C111.201 397.201 110.177 398.341 109.093 399.425C106.475 402.043 103.57 404.368 100.412 406.345C93.6584 410.592 85.8051 413.23 77.3717 413.775C76.3326 413.84 75.2734 413.876 74.2092 413.876C64.1517 413.876 54.8003 410.859 47.0025 405.69C44.6521 404.141 42.4529 402.391 40.4101 400.474C36.6978 396.974 33.5252 392.923 31.0386 388.429C27.1094 381.353 24.875 373.197 24.875 364.526C24.875 350.913 30.3981 338.571 39.3257 329.638C48.2584 320.72 60.5856 315.197 74.2142 315.197C87.8428 315.197 100.17 320.72 109.103 329.638C118.015 338.571 123.538 350.908 123.538 364.526Z",
  fill: "#DFEBFD"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M200.693 355.367H152.867V361.566H200.693V355.367Z",
  fill: "#0056D2"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M212.476 367.77H152.867V373.968H212.476V367.77Z",
  fill: "#0056D2"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M261.123 367.77H217.227V373.968H261.123V367.77Z",
  fill: "#0056D2"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M196.764 379.905H152.867V386.104H196.764V379.905Z",
  fill: "#0056D2"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M237.714 355.367H205.832V361.566H237.714V355.367Z",
  fill: "#0056D2"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M309.08 355.367H244.594V361.566H309.08V355.367Z",
  fill: "#0056D2"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M211.193 468.927H163.367V475.125H211.193V468.927Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M222.976 481.329H163.367V487.528H222.976V481.329Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M271.623 481.329H227.727V487.528H271.623V481.329Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M207.264 493.465H163.367V499.664H207.264V493.465Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M248.214 468.927H216.332V475.125H248.214V468.927Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M319.58 468.927H255.094V475.125H319.58V468.927Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M255.748 570.187H207.922V576.386H255.748V570.187Z",
  fill: "#0056D2"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M267.53 582.59H207.922V588.789H267.53V582.59Z",
  fill: "#0056D2"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M316.178 582.59H272.281V588.789H316.178V582.59Z",
  fill: "#0056D2"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M251.819 594.726H207.922V600.925H251.819V594.726Z",
  fill: "#0056D2"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M292.769 570.187H260.887V576.386H292.769V570.187Z",
  fill: "#0056D2"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M364.134 570.187H299.648V576.386H364.134V570.187Z",
  fill: "#0056D2"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M221.061 324.67H153.352V333.451H221.061V324.67Z",
  fill: "#0056D2"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M322.092 324.67H228.543V333.451H322.092V324.67Z",
  fill: "#0056D2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M194.87 152.852C192.863 152.019 191.038 150.838 189.488 149.351C187.893 147.863 186.661 146.113 185.838 144.146C184.925 142.132 184.469 140.033 184.469 137.802C184.469 128.832 192.132 121.524 201.483 121.524C204.128 121.524 206.777 122.136 209.102 123.275C211.428 124.367 213.527 126.075 215.078 128.089L215.809 128.964L210.927 132.423L210.245 131.547C208.194 128.879 205 127.345 201.488 127.345C195.468 127.345 190.537 132.028 190.537 137.802C190.537 143.623 195.463 148.348 201.488 148.348C204.956 148.348 208.15 146.818 210.245 144.146L210.927 143.313L215.764 146.725L215.034 147.6C213.439 149.656 211.428 151.275 209.058 152.414C206.732 153.553 204.132 154.122 201.488 154.122C199.206 154.122 196.969 153.684 194.87 152.852Z",
  fill: "#0056D2"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M220.373 151.058C218.322 149.002 217.18 146.333 217.18 143.618C217.18 140.861 218.318 138.192 220.373 136.178C222.473 134.253 225.21 133.157 228.129 133.157C231.141 133.157 233.879 134.249 235.836 136.178C237.936 138.192 239.074 140.818 239.074 143.618C239.074 146.418 237.936 149.044 235.836 151.058C233.785 153.025 231.048 154.122 228.129 154.122C225.303 154.122 222.517 153.03 220.373 151.058ZM222.566 143.618C222.566 146.639 225.073 149.087 228.129 149.087C231.23 149.087 233.741 146.635 233.741 143.618C233.741 140.597 231.234 138.15 228.129 138.15C225.073 138.15 222.566 140.601 222.566 143.618Z",
  fill: "#0056D2"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M270.096 153.642V142.921C270.096 140.602 268.046 138.545 265.671 138.545C263.208 138.545 261.202 140.559 261.202 142.921V153.642H255.501V142.921C255.501 140.559 253.494 138.545 251.075 138.545C248.657 138.545 246.65 140.602 246.65 142.921V153.642H240.949V133.599H246.65V135.044C248.063 133.688 249.569 133.204 251.075 133.204C252.4 133.204 253.72 133.468 255 133.99C256.187 134.517 257.281 135.261 258.283 136.178C258.283 136.221 258.327 136.221 258.376 136.268C258.42 136.225 258.42 136.225 258.469 136.178C259.425 135.261 260.52 134.517 261.751 133.99C263.027 133.463 264.351 133.204 265.676 133.204C268.369 133.204 270.92 134.211 272.838 136.004C274.756 137.886 275.802 140.338 275.802 142.917V153.637H270.096V153.642Z",
  fill: "#0056D2"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M296.964 136.225C299.015 138.239 300.157 140.865 300.157 143.618C300.157 146.376 299.019 149.001 296.964 151.011C294.913 152.978 292.176 154.032 289.257 154.032C287.339 154.032 285.607 153.378 284.101 152.065L283.871 151.891V165.279H278.352V133.599H283.871V135.175L284.101 134.959C285.744 133.429 287.613 133.208 289.257 133.208C292.131 133.204 294.864 134.258 296.964 136.225ZM294.638 143.618C294.638 140.729 292.176 138.324 289.257 138.324C286.338 138.324 283.875 140.729 283.875 143.618C283.875 146.461 286.338 148.912 289.257 148.912C292.176 148.912 294.638 146.465 294.638 143.618Z",
  fill: "#0056D2"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M302.207 153.641V121.523H308.138V153.641H302.207Z",
  fill: "#0056D2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M312.695 127.824C312.695 126.906 313.059 126.073 313.745 125.461C314.427 124.807 315.295 124.454 316.252 124.454C318.17 124.454 319.765 125.984 319.765 127.824C319.765 129.663 318.17 131.193 316.252 131.193C314.294 131.193 312.695 129.659 312.695 127.824ZM313.289 153.64V133.598H319.22V153.64H313.289Z",
  fill: "#0056D2"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M325.615 151.015C323.565 149.001 322.422 146.376 322.422 143.622C322.422 140.865 323.56 138.239 325.615 136.229C327.666 134.262 330.404 133.208 333.323 133.208C335.241 133.208 336.972 133.862 338.478 135.175L338.709 135.349V133.599H344.228V153.641H338.709V152.065L338.478 152.282C336.835 153.811 334.966 154.032 333.323 154.032C330.448 154.032 327.711 152.983 325.615 151.015ZM327.941 143.618C327.941 146.507 330.404 148.912 333.323 148.912C336.242 148.912 338.704 146.507 338.704 143.618C338.704 140.775 336.242 138.324 333.323 138.324C330.404 138.324 327.941 140.775 327.941 143.618Z",
  fill: "#0056D2"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M362.617 153.642V142.921C362.617 140.559 360.655 138.719 358.192 138.719C355.822 138.719 353.767 140.602 353.767 142.921V153.642H348.066V133.599H353.767V135.044C355.18 133.688 356.686 133.204 358.192 133.204C360.929 133.204 363.485 134.211 365.399 136.004C367.317 137.886 368.362 140.338 368.362 142.917V153.637H362.617V153.642Z",
  fill: "#0056D2"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M379.893 153.641C377.887 153.641 376.017 152.897 374.649 151.584C373.236 150.229 372.505 148.478 372.505 146.553V138.238H369.586V133.73H372.505V125.853H377.931V133.73H383.999V138.238H377.931V146.464C377.931 147.556 378.936 148.563 379.937 148.563H383.906L385.363 153.641H379.893Z",
  fill: "#0056D2"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M175.584 154.732H184.723C185.396 154.732 185.79 154.023 185.4 153.509L159.961 119.708C159.806 119.5 159.553 119.377 159.283 119.377H150.144C149.471 119.377 149.077 120.087 149.467 120.601L174.906 154.401C175.057 154.609 175.314 154.732 175.584 154.732Z",
  fill: "#0056D2"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M159.57 154.842H149.497C148.935 154.842 148.603 154.231 148.93 153.789L161.63 136.712C161.794 136.491 162.064 136.355 162.348 136.355H171.982C172.691 136.355 173.108 137.112 172.7 137.664L160.133 154.562C160.005 154.74 159.796 154.842 159.57 154.842Z",
  fill: "#00E7C5"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M173.236 129.562C175.766 129.562 177.816 127.595 177.816 125.169C177.816 122.743 175.766 120.776 173.236 120.776C170.707 120.776 168.656 122.743 168.656 125.169C168.656 127.595 170.707 129.562 173.236 129.562Z",
  fill: "#00E7C5"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M87.2951 392.242H101.591C102.645 392.242 103.262 391.132 102.652 390.328L62.8535 337.45C62.6109 337.124 62.2159 336.931 61.7932 336.931H47.4969C46.4435 336.931 45.8268 338.041 46.4366 338.846L86.2348 391.724C86.4705 392.049 86.8724 392.242 87.2951 392.242Z",
  fill: "#0056D2"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M62.2468 392.414H46.4883C45.6082 392.414 45.0884 391.457 45.6012 390.766L65.4692 364.051C65.7256 363.705 66.1483 363.492 66.5918 363.492H81.6643C82.7731 363.492 83.4245 364.676 82.7869 365.54L63.1269 391.975C62.9259 392.255 62.6002 392.414 62.2468 392.414Z",
  fill: "#00E7C5"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M83.626 352.866C87.5831 352.866 90.791 349.788 90.791 345.993C90.791 342.197 87.5831 339.119 83.626 339.119C79.6688 339.119 76.4609 342.197 76.4609 345.993C76.4609 349.788 79.6688 352.866 83.626 352.866Z",
  fill: "#00E7C5"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M138.008 605.856H150.677C151.61 605.856 152.156 604.872 151.616 604.159L116.351 557.304C116.136 557.015 115.786 556.844 115.411 556.844H102.743C101.81 556.844 101.263 557.828 101.804 558.541L137.069 605.396C137.278 605.685 137.634 605.856 138.008 605.856Z",
  fill: "#0056D2"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M115.812 606.008H101.849C101.069 606.008 100.608 605.16 101.063 604.547L118.668 580.875C118.895 580.569 119.269 580.38 119.662 580.38H133.018C134.001 580.38 134.578 581.429 134.013 582.194L116.592 605.619C116.414 605.867 116.125 606.008 115.812 606.008Z",
  fill: "#00E7C5"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M134.755 570.964C138.262 570.964 141.104 568.237 141.104 564.874C141.104 561.51 138.262 558.783 134.755 558.783C131.249 558.783 128.406 561.51 128.406 564.874C128.406 568.237 131.249 570.964 134.755 570.964Z",
  fill: "#00E7C5"
});

var _ref57 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M323.753 262.052H384.837C389.337 262.052 391.973 257.309 389.367 253.872L219.32 27.9392C218.284 26.5475 216.596 25.7239 214.79 25.7239H153.706C149.205 25.7239 146.57 30.4669 149.175 33.9035L319.222 259.837C320.229 261.228 321.946 262.052 323.753 262.052Z",
  fill: "#0056D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.746 262.786H149.414C145.654 262.786 143.433 258.696 145.624 255.743L230.515 141.597C231.61 140.121 233.416 139.212 235.311 139.212H299.712C304.449 139.212 307.233 144.267 304.509 147.959L220.507 260.912C219.648 262.105 218.256 262.786 216.746 262.786Z",
  fill: "#00E7C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.102 93.8069C325.01 93.8069 338.717 80.6588 338.717 64.4398C338.717 48.2208 325.01 35.0728 308.102 35.0728C291.195 35.0728 277.488 48.2208 277.488 64.4398C277.488 80.6588 291.195 93.8069 308.102 93.8069Z",
  fill: "#00E7C5"
}));

function SvgBillingCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 711,
    viewBox: "0 0 483 711",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingCancel);
export default __webpack_public_path__ + "static/media/billing-cancel.2487caf2.svg";
export { ForwardRef as ReactComponent };